import { FC } from 'react'

import { Button, FooterActionBarWrapper } from './Keyboard.styles'
import { KeyboardBottomActionBarProps } from './types'

export const KeyboardFooterActionBar: FC<KeyboardBottomActionBarProps> = ({
  config,
  focusIdPrefix,
}) => (
  <FooterActionBarWrapper>
    {config.map(({ onClick, icon, text = '' }, index) => (
      <Button
        key={`${focusIdPrefix}${text}${index}`}
        text={text}
        iconSrc={icon}
        onClick={onClick}
        hideLabel={!!icon}
        focusId={`${focusIdPrefix}${text}${index}`}
      />
    ))}
  </FooterActionBarWrapper>
)
